import {
  LOAD_INITIAL_FILTERS,
  LOAD_INITIAL_PARAMS,
  LOAD_TILE_DATA,
  NetworkDashboardAction,
} from './../../actions/network-dashboard-actions/network-dashboard-actions';

export const initialState = { tileData: { loaded: false, data: {} }, initialFilters: { loaded: false, data: [] } };

export function reducer(state = initialState, action: NetworkDashboardAction) {
  switch (action.type) {
    case LOAD_INITIAL_FILTERS:
      const initialFilters = action.payload;
      return { ...state, ...{ initialFilters: { loaded: true, data: initialFilters } } };

    case LOAD_INITIAL_PARAMS:
      const initialParams = action.payload;
      return { ...state, ...{ initialParams: { loaded: true, data: initialParams } } };

    case LOAD_TILE_DATA:
      const tileData = action.payload;
      return { ...state, ...{ tileData: { loaded: true, data: tileData } } };

    default:
      return state;
  }
}
